export default __webpack_public_path__ + "static/media/EAST3090.34I-39634_-23480_0.a962080f.jpg";